import { apiService, utilService } from "../../../services";
import { apiServiceConstants } from "../../../constants";
import dayjs from "dayjs";

const getNotesContainerList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patients-notes/?reg_code=${utilService.getNetwork()}&timezone=${
        Intl.DateTimeFormat().resolvedOptions().timeZone
      }`,
      params,
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesContainerResp = res as any;
      const notesContainerResponse = setNotesContainerModel(notesContainerResp);
      const result: any = {
        isSuccess: notesContainerResp.isSuccess,
        displayNotesContainer: notesContainerResponse,
        status: notesContainerResp.status,
        message: notesContainerResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
        displayNotesContainer: [],
      };
      return result;
    });

  return respApiResult;
};

const addNotesCardList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/case-patients-notes/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as any;
      const notesCardResponse = setNotesCardsModel(notesCardResp);
      const result: any = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResponse,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const getUpdatedNotesCardList = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `sboard/unit/note/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const updatedNotesCardResp = res as any;
      const updatedNotesCardResponse =
        setUpdatedNotesCardsModel(updatedNotesCardResp);
      const result: any = {
        isSuccess: updatedNotesCardResp.isSuccess,
        displayUpdatedNotesCard: updatedNotesCardResponse,
        status: updatedNotesCardResponse.status,
        message: updatedNotesCardResponse.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });

  return respApiResult;
};

const setNotesContainerModel = (payload: any): any => {
  let NotesContainerListArray = payload.result?.map((object: any) => {
    return {
      count: object.count,
      next: object.next,
      previous: object.previous,
      data: mapData(object.data),
    };
  });

  return NotesContainerListArray;
};

const getFormattedDateAndTime = (date: any) => {
  const today = dayjs(date).format("MM-DD-YYYY hh:mm A");
  return today;
};

const mapData = (groupData: Array<any>): any => {
  let NotesDataListArray = groupData.map((object: any) => {
    return {
      id: object.id,
      userName: object.added_by,
      dateTime: getFormattedDateAndTime(object.created_on),
      note: object.note,
    };
  });

  return NotesDataListArray;
};

const setNotesCardsModel = (payload: any): any => {
  let NotesCardListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      userName: object.added_by,
      dateTime: getFormattedDateAndTime(object.created_on),
      note: object.note,
    };
  });
  return NotesCardListArray;
};

const setUpdatedNotesCardsModel = (payload: any): any => {
  let UpdatedNotesContainerListArray = payload.result?.map((object: any) => {
    return {
      id: object.id,
      userName: object.user_name,
      dateTime: object.date_time,
      note: object.note,
    };
  });

  return UpdatedNotesContainerListArray;
};

const getContactDetailsOfEmergency = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/emergency-contact-details/?reg_code=${utilService.getNetwork()}&site_network_code=${
        params.site_network_code
      }&site_id=${params.site_id}`,
      "",
      apiServiceConstants.GET,
      utilService.getDeviceType()
    )
    .then((res) => {
      const resp = res as any;
      const result: any = {
        isSuccess: resp.isSuccess,
        result: resp,
        status: resp.status,
        message: resp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const transferPatient = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/transfer-case-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const notesCardResp = res as any;
      const result: any = {
        isSuccess: notesCardResp.isSuccess,
        displayNotesCard: notesCardResp,
        status: notesCardResp.status,
        message: notesCardResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const addMRN = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/add-mrn-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const mrnResp = res as any;
      const result: any = {
        isSuccess: mrnResp.isSuccess,
        displayNotesCard: mrnResp,
        status: mrnResp.status,
        message: mrnResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const stopTimer = async (params: any): Promise<any> => {
  const respApiResult = await apiService
    .apiCall(
      `ems/stop-timer-case-patient/?reg_code=${utilService.getNetwork()}`,
      params,
      apiServiceConstants.POST,
      utilService.getDeviceType()
    )
    .then((res) => {
      const mrnResp = res as any;
      const result: any = {
        isSuccess: mrnResp.isSuccess,
        displayNotesCard: mrnResp,
        status: mrnResp.status,
        message: mrnResp.message,
      };
      return result;
    })
    .catch((err) => {
      const result: any = {
        isSuccess: false,
        message: err.message,
        status: err.status,
      };
      return result;
    });
  return respApiResult;
};

const handleErrorResponse = () => {};

export const notesContainerService = {
  getNotesContainerList,
  addNotesCardList,
  getUpdatedNotesCardList,
  handleErrorResponse,
  transferPatient,
  addMRN,
  stopTimer,
  getContactDetailsOfEmergency,
};
